import GeoJSON from 'ol/format/GeoJSON';
import OLVectorTileLayer from 'ol/layer/VectorTile';
import dayjs from 'dayjs';

const format = new GeoJSON();
export function getExtentForGeometry(geometry) {
  return format.readGeometry(geometry).getExtent();
}

export const formatCoords = (coordinate, opt_precision = 5) => {
  if (coordinate) {
    return `${Math.abs(coordinate[1].toFixed(opt_precision))}\u00b0${
      coordinate[1] < 0 ? 'S' : 'N'
    },  ${Math.abs(coordinate[0].toFixed(opt_precision))}\u00b0${
      coordinate[0] < 0 ? 'W' : 'E'
    }`;
  } else {
    return '';
  }
};

export const getFeatureFromEvent = event => {
  const features = event.map.getFeaturesAtPixel(event.pixel, {
    layerFilter: layer => layer instanceof OLVectorTileLayer,
  });
  return features && features[0];
};

export const getCenterForGeometry = geometry => {
  const extent = getExtentForGeometry(geometry);
  return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
};

export const getVisualizationSeries = feed => {
  const source = feed.source[0];
  return source.config.visualization_series_id || source.config.series_id;
};

export function getMosaicsByDate(mosaicsInfo, observedDate) {
  return mosaicsInfo
    .filter(mosaic => dayjs(mosaic.first_acquired).isSame(dayjs(observedDate)))
    .sort((a, b) => {
      return a.last_acquired > b.last_acquired ? -1 : 1;
    });
}
